import { useMutation, useQueryClient } from "react-query";
import { endpoints } from "utils/endpoints";
import http from "utils/http";

const addLanguages = (postData) => {
  return http().post(endpoints.quotes.postQuoteLanguages, postData);
};

export function usePostLanguages() {
  const queryClient = useQueryClient();
  return useMutation(addLanguages, {
    onSuccess: () => {
      queryClient.invalidateQueries(["addLanguages"]);
    },
    onError: (errorData) => {
      const errorMessage = errorData?.error?.message || errorData?.message;
      alert(errorMessage);
    },
  });
}
